export enum FirstValidatedWithEnum {
  email_pin = 'email_pin',
  adm_pin = 'adm_pin',
  zero_trust_allowlist = 'zero_trust_allowlist',
  ip_history = 'ip_history',
  password_reset = 'password_reset',
  auto_register_next_device = 'auto_register_next_device',
}

export interface TrustedDeviceFields {
  device_uuid: string;
  created_at: string;
  updated_at: string;
  last_validated_at: string;
  last_validated_ip: string;
  first_validated_with: FirstValidatedWithEnum;
  last_login_version: string;
  enabled: boolean;
  disabled_on?: string;
  disabled_with?: string;
  disabled_by?: string;
  os: string;
  browser: string;
  user_agent: string;
}

export type TrustedDeviceResponse = PaginatedResponse<TrustedDeviceFields>;

export interface UserTrustedDevicesState {
  readonly isLoading: boolean;
  readonly trustedDevicesList: TrustedDeviceResponse;
  readonly isLoadingTrustedDevicesList: boolean;
  readonly isDeleting: boolean;
}
